import React, { useState } from 'react';
import { Popover } from '@mantine/core';

import { showToast } from 'utils/utility';
import { useFlightData } from 'libs/data-access';
import { IFlightOnlineBookingList } from 'libs/data-access/types';
import { EButton, ECheckbox, EPopover, ESegmentedControl, ETextInput } from 'libs/ui';

interface IProps {
    flightTicket: IFlightOnlineBookingList;
    handleRefresh: () => void;
};

export default function ResolveTicket({ ...props }: IProps) {

    const {
        postFlightData
    } = useFlightData();

    const [resolveTicketState, setResolveTicketState] = useState<{
        opened: boolean;
        selectedBooking: number;
        supplierPnr: string | null;
        providerPnr: string | null;
        ticketNumber: string | null;
        confirmed: boolean;
        isSaving: boolean;
    }>({
        opened: false,
        selectedBooking: 0,
        supplierPnr: null,
        providerPnr: null,
        ticketNumber: null,
        confirmed: false,
        isSaving: false
    });


    // HADNLER FUNCTIONS
    const closePopover = () => setResolveTicketState({
        opened: false,
        selectedBooking: 0,
        supplierPnr: null,
        providerPnr: null,
        ticketNumber: null,
        confirmed: false,
        isSaving: false
    });


    // API CALLS
    const resolveTicket = async () => {

        if (!resolveTicketState.selectedBooking) {
            showToast({
                time: 5 * 1000,
                type: "warning",
                message: "Please select a booking and provide the ticket information first!"
            });
            return;
        };

        if (!resolveTicketState.supplierPnr && !resolveTicketState.providerPnr && !resolveTicketState.ticketNumber) {
            showToast({
                type: "warning",
                message: "Please fill the ticket information!"
            });
            return;
        };

        // console.log("resolveTicketState: ", resolveTicketState);

        // setResolveTicketState({ ...resolveTicketState, isSaving: true });

        const response = await postFlightData(`/booking/${resolveTicketState.selectedBooking}/pnr-details?supplierPnr=${resolveTicketState.supplierPnr}&providerPnr=${resolveTicketState.providerPnr}&ticketNumber=${resolveTicketState.ticketNumber}`, null);

        if (response.isSuccess) {
            console.log("Response for resolving ticket: ", response);
            showToast({
                type: "success",
                message: "Ticket resolved successfully!"
            });
            closePopover();
            props.handleRefresh();
        } else {
            console.log("Error while resolving ticket: ", response);
            showToast({
                type: "error",
                message: response.message || "Error while resolving ticket!"
            });
        };

        setResolveTicketState({ ...resolveTicketState, isSaving: false });

    };


    return (
        <EPopover
            width={450}
            opened={resolveTicketState.opened}
            onClose={closePopover}
        >
            <Popover.Target>
                <div>
                    <EButton
                        size="sm"
                        variant="light"
                        color="green"
                        onClick={() => setResolveTicketState({ ...resolveTicketState, opened: !resolveTicketState.opened })}
                    >Resolve</EButton>
                </div>
            </Popover.Target>

            <Popover.Dropdown>
                <div className="w-96 p-2">
                    <h3 className="text-lg font-medium mb-4">Resolve Ticket</h3>
                    <div className="flex flex-col gap-6">
                        <ESegmentedControl
                            fullWidth
                            data={
                                props.flightTicket.bookingResponses.map((eachBooking, index) => ({
                                    label: `${eachBooking.flightSupplierName} (${eachBooking?.pnrDetail?.supplierPnr || eachBooking.id})`,
                                    value: String(eachBooking.id),
                                    // disabled: eachBooking.bookingStatus !== "FAILED" && eachBooking.bookingStatus !== "TICKETING_PENDING"
                                }))
                            }
                            value={resolveTicketState.selectedBooking.toString()}
                            onChange={(value) => setResolveTicketState({ ...resolveTicketState, selectedBooking: Number(value) })}
                        />

                        {
                            resolveTicketState.selectedBooking
                                ?
                                <>
                                    <ETextInput
                                        label="Airline PNR"
                                        placeholder="Enter airline PNR"
                                        value={resolveTicketState.supplierPnr ?? undefined}
                                        onChange={(e) => setResolveTicketState({ ...resolveTicketState, supplierPnr: e.target.value })}
                                    />
                                    <ETextInput
                                        label="GDS PNR"
                                        placeholder="Enter GDS PNR"
                                        value={resolveTicketState.providerPnr ?? undefined}
                                        onChange={(e) => setResolveTicketState({ ...resolveTicketState, providerPnr: e.target.value })}
                                    />
                                    <ETextInput
                                        label="Ticket Number"
                                        placeholder="Enter ticket no."
                                        value={resolveTicketState.ticketNumber ?? undefined}
                                        onChange={(e) => setResolveTicketState({ ...resolveTicketState, ticketNumber: e.target.value })}
                                    />

                                    <ECheckbox
                                        // indeterminate
                                        label="Are you sure you want to resolve this ticket?"
                                        checked={resolveTicketState.confirmed}
                                        onChange={(e) => setResolveTicketState({ ...resolveTicketState, confirmed: e.target.checked })}
                                    />

                                    {
                                        resolveTicketState.confirmed
                                            ?
                                            <div className="flex justify-end gap-2">
                                                <EButton
                                                    variant="light"
                                                    onClick={closePopover}
                                                >Cancel</EButton>
                                                <EButton
                                                    onClick={resolveTicket}
                                                >Save</EButton>
                                            </div>
                                            :
                                            <></>
                                    }
                                </>
                                :
                                <></>
                        }
                    </div>
                </div>
            </Popover.Dropdown>
        </EPopover>
    )
}